import { useBatchTransitionContext } from "@/modules/batch-transition/batch-transition.context";

export const useBatchTransitionFooter = () => {
  const { onSubmitClick, hasChanges, isLoading, isFinished } =
    useBatchTransitionContext();

  return {
    disabledSubmit: !hasChanges,
    isLoading,
    isFinished,
    onSubmitClick,
  };
};
